import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const VimeoIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    fill={props.color ?? "#000000"}
    height="16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-143 145 512 512"
    {...props}
  >
    <g>
      <path
        d="M113,145c-141.4,0-256,114.6-256,256s114.6,256,256,256s256-114.6,256-256S254.4,145,113,145z M272.8,560.7
		c-20.8,20.8-44.9,37.1-71.8,48.4c-27.8,11.8-57.4,17.7-88,17.7c-30.5,0-60.1-6-88-17.7c-26.9-11.4-51.1-27.7-71.8-48.4
		c-20.8-20.8-37.1-44.9-48.4-71.8C-107,461.1-113,431.5-113,401s6-60.1,17.7-88c11.4-26.9,27.7-51.1,48.4-71.8
		c20.9-20.8,45-37.1,71.9-48.5C52.9,181,82.5,175,113,175s60.1,6,88,17.7c26.9,11.4,51.1,27.7,71.8,48.4
		c20.8,20.8,37.1,44.9,48.4,71.8c11.8,27.8,17.7,57.4,17.7,88c0,30.5-6,60.1-17.7,88C309.8,515.8,293.5,540,272.8,560.7z"
      />
      <path
        d="M203.5,296.4c-35.6-1.1-59.7,18.8-72.3,59.7c6.5-2.7,12.8-4,18.9-4c13,0,18.7,7.3,17.2,21.8c-0.8,8.9-6.5,21.7-17.2,38.5
		s-18.8,25.2-24.1,25.2c-6.9,0-13.2-13-18.9-39c-1.9-7.6-5.4-27.1-10.3-58.5c-4.6-29-16.8-42.6-36.7-40.7c-8.5,0.8-21.1,8.4-37.9,23
		c-12.3,11-24.7,22.1-37.3,33.2l12,15.5C8.4,363,15.1,359,17,359c8.8,0,17,13.7,24.7,41.3c6.9,25.2,13.8,50.4,20.7,75.7
		c10.3,27.6,22.9,41.3,37.8,41.3c24.1,0,53.6-22.5,88.4-67.7c33.7-43.2,51.1-77.2,52.2-102.1C242.4,314.3,230,297.3,203.5,296.4z"
      />
    </g>
  </svg>
)
